module.exports = __webpack_public_path__ + "img/Love.96439b58.svg";